'use client'

import { useTranslations } from 'next-intl'
import React from 'react'

import { Logo } from '@/components/Logo/Logo'
import { LocaleLink } from '@/components/LocaleLink'

type HeaderBrandProps = {
  siteTitle: string
  logoSrc?: string | null
  logoAlt?: string | null
  logoInvertClassName?: string
  logoWidthPx: number
}

export function HeaderBrand({
  siteTitle,
  logoSrc,
  logoAlt,
  logoInvertClassName,
  logoWidthPx,
}: HeaderBrandProps) {
  const tArchive = useTranslations('Archive')
  const tFooter = useTranslations('Footer')
  const hasLogo = Boolean(logoSrc?.trim())
  const title = siteTitle.trim() || tArchive('breadcrumb.home')
  const homeLabel = hasLogo
    ? tFooter('homeAria', { name: logoAlt?.trim() || title })
    : tFooter('homeAria', { name: title })

  return (
    <LocaleLink
      href="/"
      rel="home"
      aria-label={homeLabel}
      className="flex min-h-10 min-w-0 shrink-0 items-center gap-2 py-1 text-lg font-semibold tracking-tighter text-foreground"
    >
      {hasLogo ? (
        <Logo
          loading="eager"
          priority="high"
          invertClassName={logoInvertClassName}
          src={logoSrc}
          alt={logoAlt?.trim() || title}
          widthPx={logoWidthPx}
          className="inline-block h-auto object-contain object-left"
        />
      ) : (
        <span className="truncate">{title}</span>
      )}
    </LocaleLink>
  )
}
